export default __webpack_public_path__ + "static/media/TextMeasure.d01a65e9.svg";